import Vue from "vue";
import axios from "axios";

function getPropByPath(object, path, defaultValue) {
  const _path = Array.isArray(path)
    ? path
    : path.split('.');
  if (object && _path.length) return getPropByPath(object[_path.shift()], _path, defaultValue);
  return object === undefined ? defaultValue : object;
}

export default {
  namespaced: true,

  state: {
    componentToken: "a900a06cc6b3e8036afb9eeb1bbf9783f0007698ed8f5cb1e373dc790e7be2e5",
    loadedFromParam: false,
    RESULTS_PER_PAGE: 100,
    EQUITY_CRITERIA: [],
    FIXED_FILTERS: [],
    ACTIVE_CRITERIA: [],
    DISPLAY_CRITERA: [],
    AVAILABLE_COUNTRYS: [],
    RESULTS: [],
    TOTAL_FILTERED: 0,
    TOTAL_RESULTS: 0,
    IS_LOADING: false,
    CURRENT_PAGE: 1,
    SYMBOL_LIST: [],
    SECTOR_LIST: [],
    SECTOR_LIST_TREE: [],
    SECTOR_LIST_SELECTED: [101],
    CURRENT_SCREENER: 'equity',
    LANG: 'en',
    AVAILABLE_EXCHANGES: [],
    CURRENT_COUNTRY: 'US',
    EXPORT: [],
    SEARCH_CRITERA: [],
    SELECTED_CRITERA: [],
    CURRENT_TAB: "overview",
    SORT_TABLE: {
      by: '',
      direction: ''
    },
    TAB_ITEMS: {
      'equity': [
        {
          label: "overview",
          hasChildren: false,
          table: {
            items: [
              { visible: true, label: 'symbol', class: 'qmod-symbol', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'name', class: 'qmod-name', key: 'companyBasics.name', format: 'formatLongnameFoward' },
              { visible: true, label: 'stockPrice', class: 'qmod-stockPrice qmod-textr', key: 'companyBasics.stockPrice', format: 'formatNumberComma', 'sortKey': 'close' },
              { visible: true, label: 'peRatio', class: 'qmod-peRatio qmod-textr', key: 'keyRatios.peRatio', format: 'formatNumberComma', 'sortKey': 'perat' },
              { visible: true, label: 'marketCapitalization', class: 'qmod-marketCapitalization qmod-textr', key: 'companyBasics.intradayMarketCapitalization', format: 'formatNumberCommaNoDec', 'sortKey': 'marketcap' },
              { visible: true, label: 'divYield', class: 'qmod-divYield qmod-textr', key: 'dividends.divYield', format: 'formatNumberComma', 'sortKey': 'divyield' },
              { visible: true, label: 'revenueGrowth3yr', class: 'qmod-revenueGrowth3yr qmod-textr', key: 'performance.revenueGrowth3yr', format: 'formatNumberComma', 'sortKey': 'revgrow3' },
              { visible: true, label: 'incomeGrowth3yr', class: 'qmod-incomeGrowth3yr qmod-textr', key: 'performance.incomeGrowth3yr', format: 'formatNumberComma', 'sortKey': 'incgrow3' },
            ]
          }
        },
        {
          label: "basics",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'Exchange', class: '', key: 'companyBasics.exchange', format: '' },
              { visible: true, label: 'Sector', class: '', key: 'companyBasics.sector', format: 'getSectorByType' },
              { visible: true, label: 'Industry', class: '', key: 'companyBasics.sector', format: 'getSectorByType2' },
              { visible: true, label: 'revenueLtm', class: 'qmod-textr', key: 'companyBasics.revenueLtm', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'freeCashFlow', class: 'qmod-textr', key: 'companyBasics.freeCashFlow', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'employees', class: 'qmod-textr', key: 'companyBasics.employees', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'marketCapitalization', class: 'qmod-textr', key: 'companyBasics.marketCapitalization', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'totalRevenue', class: 'qmod-textr', key: 'companyBasics.totalRevenue', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'stockPrice', class: 'qmod-textr', key: 'companyBasics.stockPrice', format: 'formatNumberComma' }
            ]
          }
        },
        {
          label: "ratios",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'latestFiscalEps', class: '', key: 'keyRatios.latestFiscalEps', format: '' },
              { visible: true, label: 'pbRatio', class: 'qmod-textr', key: 'keyRatios.pbRatio', format: 'formatNumberComma' },
              { visible: true, label: 'peRatio', class: 'qmod-textr', key: 'keyRatios.peRatio', format: 'formatNumberComma' },
              { visible: true, label: 'currentRatio', class: 'qmod-textr', key: 'keyRatios.currentRatio', format: 'formatNumberComma' },
              { visible: true, label: 'quickRatio', class: 'qmod-textr', key: 'keyRatios.quickRatio', format: 'formatNumberComma' },
              { visible: true, label: 'debtToEquityRatio', class: 'qmod-textr', key: 'keyRatios.debtToEquityRatio', format: 'formatNumberComma' },
              { visible: true, label: 'bvps', class: 'qmod-textr', key: 'keyRatios.bvps', format: 'formatNumberComma' },
              { visible: true, label: 'pcfRatio', class: 'qmod-textr', key: 'keyRatios.pcfRatio', format: 'formatNumberComma' },
              { visible: true, label: 'debtCapitalRatio', class: 'qmod-textr', key: 'keyRatios.debtCapitalRatio', format: 'formatNumberComma' },
            ]
          }
        },
        {
          label: "performance",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'priceChange', class: 'qmod-textr', key: 'performance.priceChange', format: 'formatNumberComma' },
              { visible: true, label: 'change52w', class: 'qmod-textr', key: 'performance.change52w', format: 'formatNumberComma' },
              { visible: true, label: 'pricePerfomance7d', class: 'qmod-textr', key: 'performance.pricePerfomance7d', format: 'formatNumberComma' },
              { visible: true, label: 'pricePerfomance30d', class: 'qmod-textr', key: 'performance.pricePerfomance30d', format: 'formatNumberComma' },
              { visible: true, label: 'pricePerfomance90d', class: 'qmod-textr', key: 'performance.pricePerfomance90d', format: 'formatNumberComma' },
              { visible: true, label: 'pricePerfomanceYtd', class: 'qmod-textr', key: 'performance.pricePerfomanceYtd', format: 'formatNumberComma' },
              { visible: true, label: 'incomeGrowth3yr', class: 'qmod-textr', key: 'performance.incomeGrowth3yr', format: 'formatNumberComma' },
              { visible: true, label: 'incomeGrowth5yr', class: 'qmod-textr', key: 'performance.incomeGrowth5yr', format: 'formatNumberComma' },
              { visible: true, label: 'revenueGrowth3yr', class: 'qmod-textr', key: 'performance.revenueGrowth3yr', format: 'formatNumberComma' },
              { visible: true, label: 'revenueGrowth5yr', class: 'qmod-textr', key: 'performance.revenueGrowth5yr', format: 'formatNumberComma' },
            ]
          }
        },
        {
          label: "dividends",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'divYield', class: 'qmod-textr', key: 'dividends.divYield', format: 'formatNumberComma' },
              { visible: true, label: 'divRate', class: 'qmod-textr', key: 'dividends.divRate', format: 'formatNumberComma' },
              { visible: true, label: 'divGrowthAvg3y', class: 'qmod-textr', key: 'dividends.divGrowthAvg3y', format: 'formatNumberComma' },
              { visible: true, label: 'divGrowthAvg5y', class: 'qmod-textr', key: 'dividends.divGrowthAvg5y', format: 'formatNumberComma' },
            ]
          }
        },
        {
          label: "profitability",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'roa', class: 'qmod-textr', key: 'profitability.roa', format: 'formatNumberComma' },
              { visible: true, label: 'roe', class: 'qmod-textr', key: 'profitability.roe', format: 'formatNumberComma' },
              { visible: true, label: 'roc', class: 'qmod-textr', key: 'profitability.roc', format: 'formatNumberComma' },
              { visible: true, label: 'grossMargin', class: 'qmod-textr', key: 'profitability.grossMargin', format: 'formatNumberComma' },
              { visible: true, label: 'ebitdaMargin', class: 'qmod-textr', key: 'profitability.ebitdaMargin', format: 'formatNumberComma' },
              { visible: true, label: 'ebitMargin', class: 'qmod-textr', key: 'profitability.ebitMargin', format: 'formatNumberComma' },
              { visible: true, label: 'revPs', class: 'qmod-textr', key: 'profitability.revPs', format: 'formatNumberComma' },
            ]
          }
        },
        {
          label: "trading",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'r2', class: 'qmod-textr', key: 'trading.r2', format: 'formatNumberComma' },
              { visible: true, label: 'alpha', class: 'qmod-textr', key: 'trading.alpha', format: 'formatNumberComma' },
              { visible: true, label: 'beta', class: 'qmod-textr', key: 'trading.beta', format: 'formatNumberComma' },
              { visible: true, label: 'stddev', class: 'qmod-textr', key: 'trading.stddev', format: 'formatNumberComma' },
              { visible: true, label: 'instHoldingPct', class: 'qmod-textr', key: 'trading.instHoldingPct', format: 'formatNumberComma' },
              { visible: true, label: 'insiderHoldingPct', class: 'qmod-textr', key: 'trading.insiderHoldingPct', format: 'formatNumberComma' },
              { visible: true, label: 'yesterdaysVolume', class: 'qmod-textr', key: 'trading.yesterdaysVolume', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'averageVolume10d', class: 'qmod-textr', key: 'trading.averageVolume10d', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'averageVolume30d', class: 'qmod-textr', key: 'trading.averageVolume30d', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'averageVolume50d', class: 'qmod-textr', key: 'trading.averageVolume50d', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'averageVolume90d', class: 'qmod-textr', key: 'trading.averageVolume90d', format: 'formatNumberCommaNoDec' },
            ]
          }
        },
        {
          label: "financials",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'currentLiabilities', class: 'qmod-textr', key: 'balanceSheet.currentLiabilities', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'totalEquity', class: 'qmod-textr', key: 'balanceSheet.totalEquity', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'bookValue', class: 'qmod-textr', key: 'balanceSheet.bookValue', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'currentAssets', class: 'qmod-textr', key: 'balanceSheet.currentAssets', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'totalAssets', class: 'qmod-textr', key: 'balanceSheet.totalAssets', format: 'formatNumberCommaNoDec' },
            ]
          }
        },
          
        {
          label: "esg",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'companyBasics.symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'esgrating', class: 'qmod-textr', key: 'equityEsgRating.companyRating', format: '' },
              { visible: true, label: 'industryadjustedscore', class: 'qmod-textr', key: 'equityEsgRating.indAdjustedScore', format: '' },
              { visible: true, label: 'pillarscoreenvironmental', class: 'qmod-textr', key: 'equityEsgRating.envPillarScore', format: '' },
              { visible: true, label: 'pillarscoresocial', class: 'qmod-textr', key: 'equityEsgRating.socPillarScore', format: '' },
              { visible: true, label: 'pillarscoregovernance', class: 'qmod-textr', key: 'equityEsgRating.govPillarScore', format: '' },
              { visible: true, label: 'pillarweightenvironmental', class: 'qmod-textr', key: 'equityEsgRating.envPillarWeight', format: '' },
              { visible: true, label: 'pillarweightsocial', class: 'qmod-textr', key: 'equityEsgRating.socPillarWeight', format: '' },
              { visible: true, label: 'pillarweightgovernance', class: 'qmod-textr', key: 'equityEsgRating.govPillarWeight', format: '' },
              
              { visible: true, label: 'opportunitiesnutritionhealth', class: 'qmod-textr', key: 'equityEsgRating.oppsNutriHealthScore', format: '' },
              { visible: true, label: 'carbonemissions', class: 'qmod-textr', key: 'equityEsgRating.carbonEmissionsScore', format: '' },
              
              { visible: true, label: 'healthsafety', class: 'qmod-textr', key: 'equityEsgRating.healthSafetyScore', format: '' },
              { visible: true, label: 'cleantech', class: 'qmod-textr', key: 'equityEsgRating.oppsClnTechScore', format: '' },
              { visible: true, label: 'opportunitiesrenewable', class: 'qmod-textr', key: 'equityEsgRating.oppsRenewEnergyScore', format: '' },
              { visible: true, label: 'productsafetyquality', class: 'qmod-textr', key: 'equityEsgRating.finProdSafetyScore', format: '' },
              { visible: true, label: 'insuringhealthdemorisk', class: 'qmod-textr', key: 'equityEsgRating.insHealthDemoRiskScore', format: '' },
              { visible: true, label: 'corporatebehaviour', class: 'qmod-textr', key: 'equityEsgRating.corpBehavScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'electronicwaste', class: 'qmod-textr', key: 'equityEsgRating.ewasteScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'waterperformancepeers', class: 'qmod-textr', key: 'equityEsgRating.waterStrsPerfRelPeerScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'privacydatasecurity', class: 'qmod-textr', key: 'equityEsgRating.privacyDataSecScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'healthsafetypeers', class: 'qmod-textr', key: 'equityEsgRating.healthSafePerfRelPeesScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'chemicalsafety', class: 'qmod-textr', key: 'equityEsgRating.chemSafetyScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'toxicreleasespeers', class: 'qmod-textr', key: 'equityEsgRating.toxicEmPerfRelPeerScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'carbonfootprint', class: 'qmod-textr', key: 'equityEsgRating.prodCarbFtprntScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'supplychain', class: 'qmod-textr', key: 'equityEsgRating.supplyChainLabScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'humancapitaldevelopment', class: 'qmod-textr', key: 'equityEsgRating.humanCapitalDevScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'controversialsourcing', class: 'qmod-textr', key: 'equityEsgRating.controvSrcScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'waterstress', class: 'qmod-textr', key: 'equityEsgRating.waterStressScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'labormanagement', class: 'qmod-textr', key: 'equityEsgRating.laborMgmtScore', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'longtermpayperformancepeers', class: 'qmod-textr', key: 'equityEsgRating.ltPayPerfVersusPeersSd', format: 'formatNumberCommaNoDec' },
            ]
          }
        },
      ],
      'mutual_fund': [
        {
          label: "overview",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'familyNames', class: '', key: 'fundName', format: 'formatLongnameFoward' },
              { visible: true, label: '', class: '', key: 'hisaFund', format: 'html' },
              { visible: true, label: 'categoryNames', class: 'qmod-textr', key: 'categoryName', format: '' },
              { visible: true, label: 'instrumentType', class: 'qmod-textr', key: 'instrumentType', format: 'formatInstrumentType' },
              { visible: true, label: 'investmentStyle', class: 'qmod-textr', key: 'investmentStyle', format: '' },
              { visible: true, label: 'avgCreditRating', class: 'qmod-textr', key: '', format: '' },
              { visible: true, label: 'indexFund', class: 'qmod-textr', key: 'indexFund', format: '' },
              { visible: true, label: 'MMfund', class: 'qmod-textr', key: '', format: '' },
              { visible: true, label: 'indexFund', class: 'qmod-textr', key: '', format: '' },
              { visible: true, label: 'mer', class: 'qmod-textr', key: '', format: '' },
            ]
          }
        },
        {
          label: "portfolio",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'inceptionDate', class: 'qmod-textr', key: 'inceptionDate', format: '' },
              { visible: true, label: 'turnover', class: 'qmod-textr', key: 'turnover', format: '' },
              { visible: true, label: 'netAssets', class: 'qmod-textr', key: 'netAssets', format: '' },
              { visible: true, label: 'managerTenure', class: 'qmod-textr', key: 'managerTenure', format: '' },
              { visible: true, label: 'assetsUnderMgmt', class: 'qmod-textr', key: 'assetsUnderMgmt', format: '' },
            ]
          }
        },
        {
          label: "rating",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'beta', class: 'qmod-textr', key: 'beta', format: '' },
              { visible: true, label: 'stdDeviation', class: 'qmod-textr', key: 'stdDeviation', format: '' },
              { visible: true, label: 'alpha', class: 'qmod-textr', key: 'alpha', format: '' },
              { visible: true, label: 'sharpeRatio', class: 'qmod-textr', key: 'sharpeRatio', format: '' },
              { visible: true, label: 'rsquared', class: 'qmod-textr', key: 'rsquared', format: '' },
              { visible: true, label: 'treynor', class: 'qmod-textr', key: 'treynor', format: '' },
              { visible: true, label: 'sortino', class: 'qmod-textr', key: 'sortino', format: '' },
              { visible: true, label: 'informationRatio', class: 'qmod-textr', key: 'informationRatio', format: '' },
              { visible: true, label: 'captureRatioUp', class: 'qmod-textr', key: 'captureRatioUp', format: '' },
              { visible: true, label: 'captureRatioDown', class: 'qmod-textr', key: 'captureRatioDown', format: '' },
            ]
          }
        },
        {
          label: "performance",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'navPerformance1Day', class: 'qmod-textr', key: 'navInfo.navPerformance1Day', format: '' },
              { visible: true, label: 'navPerformance1Month', class: 'qmod-textr', key: 'navInfo.navPerformance1Month', format: '' },
              { visible: true, label: 'navPerformance3Month', class: 'qmod-textr', key: 'navInfo.navPerformance3Month', format: '' },
              { visible: true, label: 'navPerformanceYTD', class: 'qmod-textr', key: 'navInfo.navPerformanceYTD', format: '' },
              { visible: true, label: 'navPerformance1Year', class: 'qmod-textr', key: 'navInfo.navPerformance1Year', format: '' },
              { visible: true, label: 'navPerformance3Year', class: 'qmod-textr', key: 'navInfo.navPerformance3Year', format: '' },
              { visible: true, label: 'navPerformance5Year', class: 'qmod-textr', key: 'navInfo.navPerformance5Year', format: '' },
              { visible: true, label: 'navPerformance10Year', class: 'qmod-textr', key: 'navInfo.navPerformance10Year', format: '' },
              { visible: true, label: 'error', class: 'qmod-textr', key: '', format: '' },
            ]
          }
        },
        {
          label: "dividends",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'dividendFrequency', class: 'qmod-textr', key: 'dividendFrequency', format: '' },
              { visible: true, label: 'distributionYield', class: 'qmod-textr', key: 'distributionYield', format: '' },
            ]
          }
        },
        {
          label: "holdings",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'topSector', class: 'qmod-textr', key: 'topSector', format: '' },
              { visible: true, label: 'topRegionName', class: 'qmod-textr', key: 'topRegionName', format: '' },

              { visible: true, label: 'holding1', class: 'qmod-textr', key: 'top10Holdings.0', format: '' },
              { visible: true, label: 'holding2', class: 'qmod-textr', key: 'top10Holdings.1', format: '' },
              { visible: true, label: 'holding3', class: 'qmod-textr', key: 'top10Holdings.2', format: '' },
              { visible: true, label: 'holding4', class: 'qmod-textr', key: 'top10Holdings.3', format: '' },
              { visible: true, label: 'holding5', class: 'qmod-textr', key: 'top10Holdings.4', format: '' },
              { visible: true, label: 'holding6', class: 'qmod-textr', key: 'top10Holdings.5', format: '' },
              { visible: true, label: 'holding7', class: 'qmod-textr', key: 'top10Holdings.6', format: '' },
              { visible: true, label: 'holding8', class: 'qmod-textr', key: 'top10Holdings.7', format: '' },
              { visible: true, label: 'holding9', class: 'qmod-textr', key: 'top10Holdings.8', format: '' },
              { visible: true, label: 'holding10', class: 'qmod-textr', key: 'top10Holdings.9', format: '' }
            ]
          }
        },
        {
          label: "pricetrading",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: '52weekabove', class: 'qmod-textr', key: '52weekabove', format: '' },
              { visible: true, label: '52weekbelow', class: 'qmod-textr', key: '52weekbelow', format: '' },

              { visible: true, label: 'nav', class: 'qmod-textr', key: 'navInfo.nav', format: '' },
              { visible: true, label: 'navChange', class: 'qmod-textr', key: 'navInfo.navChange', format: '' },
            ]
          }
        },
        {
          label: "purchaseinfo",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'fundSaleStatus', class: 'qmod-textr', key: 'fundSaleStatus', format: '' },
              { visible: true, label: 'rrspEligibility', class: 'qmod-textr', key: 'rrspEligibility', format: '' },

              { visible: true, label: 'minimumInitialInvestment', class: 'qmod-textr', key: 'minimumInitialInvestment', format: '' },
              { visible: true, label: 'minimumSubsequentInvestment', class: 'qmod-textr', key: 'minimumSubsequentInvestment', format: '' },
              { visible: true, label: 'rrspMinInvestment', class: 'qmod-textr', key: 'rrspMinInvestment', format: '' },
            ]
          }
        },

        {
          label: "esg",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'esgrating', class: 'qmod-textr', key: 'fundEsgRatings.fundEsgRating', format: '' },
              { visible: true, label: 'qualityscore', class: 'qmod-textr', key: 'fundEsgRatings.fundEsgQualityScore', format: 'formatNumberComma' },
              { visible: true, label: 'fundpeerrankscore', class: 'qmod-textr', key: 'fundEsgRatings.fundRankPeerScore', format: 'formatNumberComma' },
              { visible: true, label: 'fundglobalrank', class: 'qmod-textr', key: 'fundEsgRatings.fundRankGlobalScore', format: 'formatNumberComma' },
              { visible: true, label: 'sustainableimpact', class: 'qmod-textr', key: 'fundImpact.fundSustainableImpactPct', format: 'formatNumberComma' },
              { visible: true, label: 'carbonintensityscore', class: 'qmod-textr', key: 'fundClimate.fundCarbonIntensityRating', format: 'formatNumberComma' },
              { visible: true, label: 'severecontroversies', class: 'qmod-textr', key: 'fundValues.fundVerySevereControversiesPct', format: 'formatNumberComma' },
              { visible: true, label: 'weapontie', class: 'qmod-textr', key: 'fundValues.fundControversiesWeaponTiePct', format: 'formatNumberComma' },
              { visible: true, label: 'tobacco', class: 'qmod-textr', key: 'fundValues.fundTobaccoTiePct', format: 'formatNumberComma' },
            ]
          }
        },
      ],
      'etf': [
        {
          label: "overview",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'familyNames', class: '', key: 'fundName', format: 'formatLongnameFoward' },
              { visible: true, label: '', class: '', key: 'commissionFree', format: 'html' },
              { visible: true, label: 'categoryNames', class: 'qmod-textr', key: 'categoryName', format: '' },
              { visible: true, label: 'instrumentType', class: 'qmod-textr', key: 'instrumentType', format: 'formatInstrumentType' },
              { visible: true, label: 'investmentStyle', class: 'qmod-textr', key: 'investmentStyle', format: '' },
              { visible: true, label: 'avgCreditQuality', class: 'qmod-textr', key: 'avgCreditQuality', format: '' },
              { visible: true, label: 'indexFund', class: 'qmod-textr', key: 'indexFund', format: '' },
              { visible: true, label: 'inverseFund', class: 'qmod-textr', key: 'inverseFund', format: '' },
              { visible: true, label: 'leveragedFund', class: 'qmod-textr', key: 'leveragedFund', format: '' },
              { visible: true, label: 'mer', class: 'qmod-textr', key: 'managementFeeRatio', format: '' },
            ]
          }
        },
        {
          label: "portfolio",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'inceptionDate', class: 'qmod-textr', key: 'inceptionDate', format: '' },
              { visible: true, label: 'turnover', class: 'qmod-textr', key: 'turnover', format: '' },
              { visible: true, label: 'netAssets', class: 'qmod-textr', key: 'netAssets', format: '' },
            ]
          }
        },
        {
          label: "rating",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'beta', class: 'qmod-textr', key: 'beta', format: '' },
              { visible: true, label: 'stdDeviation', class: 'qmod-textr', key: 'stdDeviation', format: '' },
              { visible: true, label: 'alpha', class: 'qmod-textr', key: 'alpha', format: '' },
              { visible: true, label: 'sharpeRatio', class: 'qmod-textr', key: 'sharpeRatio', format: '' },
              { visible: true, label: 'rsquared', class: 'qmod-textr', key: 'rsquared', format: '' },
              { visible: true, label: 'treynor', class: 'qmod-textr', key: 'treynor', format: '' },
              { visible: true, label: 'sortino', class: 'qmod-textr', key: 'sortino', format: '' },
              { visible: true, label: 'informationRatio', class: 'qmod-textr', key: 'informationRatio', format: '' },
              { visible: true, label: 'captureRatioUp', class: 'qmod-textr', key: 'captureRatioUp', format: '' },
              { visible: true, label: 'captureRatioDown', class: 'qmod-textr', key: 'captureRatioDown', format: '' },
            ]
          }
        },
        {
          label: "performance",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'navPerformance1Day', class: 'qmod-textr', key: 'navInfo.navPerformance1Day', format: '' },
              { visible: true, label: 'navPerformance1Month', class: 'qmod-textr', key: 'navInfo.navPerformance1Month', format: '' },
              { visible: true, label: 'navPerformance3Month', class: 'qmod-textr', key: 'navInfo.navPerformance3Month', format: '' },
              { visible: true, label: 'navPerformanceYTD', class: 'qmod-textr', key: 'navInfo.navPerformanceYTD', format: '' },
              { visible: true, label: 'navPerformance1Year', class: 'qmod-textr', key: 'navInfo.navPerformance1Year', format: '' },
              { visible: true, label: 'navPerformance3Year', class: 'qmod-textr', key: 'navInfo.navPerformance3Year', format: '' },
              { visible: true, label: 'navPerformance5Year', class: 'qmod-textr', key: 'navInfo.navPerformance5Year', format: '' },
              { visible: true, label: 'navPerformance10Year', class: 'qmod-textr', key: 'navInfo.navPerformance10Year', format: '' },
              { visible: true, label: 'error', class: 'qmod-textr', key: '', format: '' },
            ]
          }
        },
        {
          label: "dividends",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'dividendFrequency', class: 'qmod-textr', key: 'dividendFrequency', format: '' },
              { visible: true, label: 'distributionYield', class: 'qmod-textr', key: 'distributionYield', format: '' },
            ]
          }
        },
        {
          label: "holdings",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'topSector', class: 'qmod-textr', key: 'topSector', format: '' },
              { visible: true, label: 'topRegionName', class: 'qmod-textr', key: 'topRegionName', format: '' },

              { visible: true, label: 'holding1', class: 'qmod-textr', key: 'top10Holdings.0', format: '' },
              { visible: true, label: 'holding2', class: 'qmod-textr', key: 'top10Holdings.1', format: '' },
              { visible: true, label: 'holding3', class: 'qmod-textr', key: 'top10Holdings.2', format: '' },
              { visible: true, label: 'holding4', class: 'qmod-textr', key: 'top10Holdings.3', format: '' },
              { visible: true, label: 'holding5', class: 'qmod-textr', key: 'top10Holdings.4', format: '' },
              { visible: true, label: 'holding6', class: 'qmod-textr', key: 'top10Holdings.5', format: '' },
              { visible: true, label: 'holding7', class: 'qmod-textr', key: 'top10Holdings.6', format: '' },
              { visible: true, label: 'holding8', class: 'qmod-textr', key: 'top10Holdings.7', format: '' },
              { visible: true, label: 'holding9', class: 'qmod-textr', key: 'top10Holdings.8', format: '' },
              { visible: true, label: 'holding10', class: 'qmod-textr', key: 'top10Holdings.9', format: '' }
            ]
          }
        },
        {
          label: "pricetrading",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: '52weekabove', class: 'qmod-textr', key: '52weekabove', format: '' },
              { visible: true, label: '52weekbelow', class: 'qmod-textr', key: '52weekbelow', format: '' },

              { visible: true, label: 'nav', class: 'qmod-textr', key: 'navInfo.nav', format: '' },
              { visible: true, label: 'navChange', class: 'qmod-textr', key: 'navInfo.navChange', format: '' },
              { visible: true, label: 'averageVolume10d', class: 'qmod-textr', key: 'averageVolume10d', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'averageVolume30d', class: 'qmod-textr', key: 'averageVolume30d', format: 'formatNumberCommaNoDec' },
              { visible: true, label: 'averageVolume50d', class: 'qmod-textr', key: 'averageVolume50d', format: 'formatNumberCommaNoDec' },
            ]
          }
        },
        {
          label: "esg",
          table: {
            items: [
              { visible: true, label: 'symbol', class: '', key: 'symbol', format: 'formatSymbolFoward' },
              { visible: true, label: 'esgrating', class: 'qmod-textr', key: 'fundEsgRatings.fundEsgRating', format: '' },
              { visible: true, label: 'qualityscore', class: 'qmod-textr', key: 'fundEsgRatings.fundEsgQualityScore', format: 'formatNumberComma' },
              { visible: true, label: 'fundpeerrankscore', class: 'qmod-textr', key: 'fundEsgRatings.fundRankPeerScore', format: 'formatNumberComma' },
              { visible: true, label: 'fundglobalrank', class: 'qmod-textr', key: 'fundEsgRatings.fundRankGlobalScore', format: 'formatNumberComma' },
              { visible: true, label: 'sustainableimpact', class: 'qmod-textr', key: 'fundImpact.fundSustainableImpactPct', format: 'formatNumberComma' },
              { visible: true, label: 'carbonintensityscore', class: 'qmod-textr', key: 'fundClimate.fundCarbonIntensityRating', format: 'formatNumberComma' },
              { visible: true, label: 'severecontroversies', class: 'qmod-textr', key: 'fundValues.fundVerySevereControversiesPct', format: 'formatNumberComma' },
              { visible: true, label: 'weapontie', class: 'qmod-textr', key: 'fundValues.fundControversiesWeaponTiePct', format: 'formatNumberComma' },
              { visible: true, label: 'tobacco', class: 'qmod-textr', key: 'fundValues.fundTobaccoTiePct', format: 'formatNumberComma' },
            ]
          }
        },
      ],
    },
    CUSTOM_TABS: {
      'equity': [],
      'mutual_fund': [],
      'etf': [],
    }
  },
  getters: {
    gSortTable: (state) => {
      return state.SORT_TABLE;
    },
    gCustomTabItems: (state) => {
      return state.CUSTOM_TABS[state.CURRENT_SCREENER];
    },
    gTabItems: (state) => {
      return state.TAB_ITEMS[state.CURRENT_SCREENER];
    },
    gSearchCritera: (state) => {
      return state.SEARCH_CRITERA;
    },
    gExchanges: (state) => {
      return state.AVAILABLE_EXCHANGES;
    },
    gEquityCriteria: (state) => {

      return state.EQUITY_CRITERIA;
    },
    gfixedFilters: (state) => {
      return state.FIXED_FILTERS;
    },
    gAvailableCountrys: (state) => {
      return state.AVAILABLE_COUNTRYS;
    },
    gCurrentCountry: (state) => {
      return state.CURRENT_COUNTRY;
    },
    gActiveCriteria: (state) => {
      return state.ACTIVE_CRITERIA;
    },
    gATotalResults: (state) => {
      return state.TOTAL_RESULTS;
    },
    gATotalFiltered: (state) => {
      return state.TOTAL_FILTERED;
    },
    gResults: (state) => {

      if (state.SORT_TABLE.by == '') return state.RESULTS;
      let sortedResults = state.RESULTS.sort((a, b) => {
        let aa = getPropByPath(a, state.SORT_TABLE.by) || (state.SORT_TABLE.direction == 'asc' ? 1 : -1);
        let bb = getPropByPath(b, state.SORT_TABLE.by) || (state.SORT_TABLE.direction == 'asc' ? -1 : 1);

        if (isNaN(bb)) {
          if (state.SORT_TABLE.direction == 'asc') {
            return bb.localeCompare ? bb.localeCompare(aa) : false;
          }
          else {
            return aa.localeCompare ? aa.localeCompare(bb) : false
          }
        }
        if (state.SORT_TABLE.direction == 'asc') {
          return parseFloat(bb) - parseFloat(aa)
        }
        else {
          return parseFloat(aa) - parseFloat(bb)
        }

      });
      return sortedResults;
    },
    gLoading: (state) => {
      return state.IS_LOADING;
    },
    gCurrentPage: state => {
      return state.CURRENT_PAGE;
    },
    gSectorSelected: (state) => {
      return state.SECTOR_LIST_SELECTED;
    },
    
    gSectorSelectedLabels: (state) => {
      const labels = [];

      state.SECTOR_LIST.forEach( sector => {
        if (state.SECTOR_LIST_SELECTED.indexOf(sector.type) !== -1) {
          labels.push(sector.label)
        }
      });

      return labels.join(',');
    },

    gSectorList: (state) => {
      return state.SECTOR_LIST;
    },
    gExport: (state) => {
      return state.EXPORT;
    },
    gSymbolList: (state) => {
      return state.SYMBOL_LIST;
    }
  },
  mutations: {
    SET_SORT_TABLE(state, SORT_ITEM) {
      // already sorting,
      if (state.SORT_TABLE.by == SORT_ITEM.key) {
        if (state.SORT_TABLE.direction == 'asc') {
          state.SORT_TABLE.direction = 'desc'
        }
        else {
          state.SORT_TABLE.direction = 'asc'
        }
      }
      else {
        state.SORT_TABLE.direction = 'asc'
        state.SORT_TABLE.by = SORT_ITEM.key
      }
      state.SORT_TABLE.sortKey = SORT_ITEM.sortKey


    },
    REMOVE_ROW(state, TAB_INDEX) {
      const CUSTOM_TABS_LS = state.CUSTOM_TABS;
      let CURRENT_TAB = CUSTOM_TABS_LS[state.CURRENT_SCREENER]
      CURRENT_TAB.splice(TAB_INDEX, 1);

      localStorage.setItem('QMOD_SCREENER_CUSTOM_TABS', JSON.stringify(CUSTOM_TABS_LS));
    },
    SET_OR_UPDATE_COLS(state, { TAB_INDEX, CRITERA }) {
      const CUSTOM_TABS_LS = state.CUSTOM_TABS;
      let CURRENT_TAB = CUSTOM_TABS_LS[state.CURRENT_SCREENER][TAB_INDEX].items;


      localStorage.setItem('QMOD_SCREENER_CUSTOM_TABS', JSON.stringify(CUSTOM_TABS_LS));

    },
    SET_OR_UPDATE_TABS(state, TAB) {
      const CUSTOM_TABS_LS = state.CUSTOM_TABS;
      CUSTOM_TABS_LS[state.CURRENT_SCREENER].push(TAB);

      localStorage.setItem('QMOD_SCREENER_CUSTOM_TABS', JSON.stringify(CUSTOM_TABS_LS));
    },
    SET_SELECTED_CRITERA(state, CRITERA) {

      const match = state.SELECTED_CRITERA.find(item => item.id === CRITERA.id);

      if (match) {
        let index = state.SELECTED_CRITERA.indexOf(match);

        state.SELECTED_CRITERA.splice(index, 1);

      }
      else {
        state.SELECTED_CRITERA.push(CRITERA);
      }

    },
    SET_SELECTED_CRITERA_ARRAY(state, CRITERA_ARRAY) {
      state.SELECTED_CRITERA = CRITERA_ARRAY;
    },
    SET_SEARCH_CRITERA(state, SEARCH_CRITERA) {
      state.SEARCH_CRITERA = SEARCH_CRITERA;
    },
    SET_EXPORT(state, EXPORT) {
      state.EXPORT = EXPORT;
    },
    SET_CURRENT_COUNTRY(state, CURRENT_COUNTRY) {
      state.CURRENT_COUNTRY = CURRENT_COUNTRY;
    },
    SET_EXCHANGES(state, exchanges) {
      state.AVAILABLE_EXCHANGES = exchanges;
    },
    SET_LANG(state, lang) {
      state.LANG = lang;
    },
    SET_CURRENT_SCREENER(state, screener) {
      state.CURRENT_SCREENER = screener;
    },
    SET_SECTOR_LIST_SELECTED(state, results) {
      state.SECTOR_LIST_SELECTED = results;
    },
    SET_SECTOR_LIST(state, results) {
      state.SECTOR_LIST = results;
    },
    SET_SECTOR_LIST_TREE(state, results) {
      state.SECTOR_LIST_TREE = results;
    },
    SET_SYMBOL_LIST(state, results) {
      state.SYMBOL_LIST = results;
    },
    SET_IS_LOADING(state, results) {
      state.IS_LOADING = results;
    },
    CLEAR_ALL(state) {
      state.EQUITY_CRITERIA = [];
      state.ACTIVE_CRITERIA = [];
      state.RESULTS = [];
      state.TOTAL_RESULTS = 0;
      state.TOTAL_FILTERED = 0;
    },
    CLEAR_ALL_PESETS(state) {
      // state.EQUITY_CRITERIA = [];
      state.ACTIVE_CRITERIA = [];
      state.RESULTS = [];
      state.TOTAL_RESULTS = 0;
      state.TOTAL_FILTERED = 0;
      state.SELECTED_CRITERA = [];
    },
    SET_TOTAL_RESULTS(state, results) {
      state.TOTAL_RESULTS = results;
    },
    SET_FILTERED_RESULTS(state, results) {
      state.RESULTS = results;
    },
    SET_COMPONENT_TOKEN(state, token) {
      state.componentToken = token;
    },
    REMOVE_ACTIVE_CRITERIA_BY_INDEX(state, index) {
      state.ACTIVE_CRITERIA.splice(index, 1);
    },
    REMOVE_ACTIVE_CRITERIA_BY_ID(state, criteriaToRemove) {
      const index = state.ACTIVE_CRITERIA.findIndex(
        (item) => item.id === criteriaToRemove.id
      );
      if (index !== -1) {
        state.ACTIVE_CRITERIA.splice(index, 1);
      }
    },
    UPDATE_ACTIVE_CRITERIA_LIST(state, ACTIVE_CRITERIA_TO_UPDATE) {
      ACTIVE_CRITERIA_TO_UPDATE.forEach((element, idx) => {
        if (!element.id) element.id = element.name;
        const item = state.ACTIVE_CRITERIA.find(
          (item) => item.id === element.id
        );
        let index = state.ACTIVE_CRITERIA.indexOf(item);
        
        if (item) {
          let element2 = Object.assign({}, item, element);
          Vue.set(state.ACTIVE_CRITERIA, index, element2);
        } else {
          state.ACTIVE_CRITERIA.push(element);
        }
      });

      state.TOTAL_FILTERED = ACTIVE_CRITERIA_TO_UPDATE.total;
    },
    SET_COUNTRYS(state, COUNTRY) {
      let defaultCountry = (state.CURRENT_COUNTRY === 'US' ? "0" : "1");

      state.AVAILABLE_COUNTRYS = [];
      COUNTRY.dropdown = Object.assign({
        selected: defaultCountry,
        list: [],
      });

      Object.entries(COUNTRY.values).forEach(([key, val]) => {
        COUNTRY.dropdown.list.push({
          label: val,
          type: key,
          avatar: val == 'US' ? '//qmod.quotemedia.com/img/flags/4x3/us.svg' : '//qmod.quotemedia.com/img/flags/4x3/ca.svg'
        });
      });

      state.AVAILABLE_COUNTRYS.push(COUNTRY);
    },
    SET_ACTIVE_CRITERIA(state, ACTIVE_CRITERIA) {
      state.ACTIVE_CRITERIA.push(ACTIVE_CRITERIA);
    },
    SET_ACTIVE_CRITERIA_FROM_PARAM(state, criteria) {
      this.loadedFromParam = true;
      const ACTIVE_CRITERIA = [];

      Object.keys(criteria).forEach(id => {
        const val = criteria[id];
        const isRange = val.indexOf(':') !== -1;

        if (isRange) {
          const [minRange, maxRange] = val.split(':');
          
          ACTIVE_CRITERIA.push({
            minRange: minRange || -Infinity,
            maxRange: maxRange || Infinity,
            id
          });
        } else {
          const criteriaItem = {
            selected: val,  
            list: [],
            id
          };

          // Special handling for exchangeGroups to populate list and format selections
          if (id === 'exchangeGroups') {
            // Populate the list from AVAILABLE_EXCHANGES
            Object.entries(state.AVAILABLE_EXCHANGES).forEach(([key, exchangeVal]) => {
              let dname;
              if (exchangeVal.id == 'TSV') {
                dname = 'TSXV';
              } else if (exchangeVal.id == 'CNQ') {
                dname = 'CSE';
              } else {
                dname = exchangeVal.id
              }
              criteriaItem.list.push({
                label: dname,
                type: key,
                displayname: exchangeVal.id,
              });
            });

            // Ensure selected values are in array format and handle both old and new formats
            let selectedValues;
            if (typeof val === 'string') {
              selectedValues = val.split(',');
            } else if (Array.isArray(val)) {
              selectedValues = val;
            } else {
              selectedValues = [val];
            }

            // Convert exchange IDs to keys if needed (for new format compatibility)
            criteriaItem.selected = selectedValues.map(selectedVal => {
              // Check if selectedVal is an exchange ID (like "AMX", "NSD", "NYE")
              // If so, find the corresponding key
              const exchangeEntry = Object.entries(state.AVAILABLE_EXCHANGES).find(([, exchangeVal]) => 
                exchangeVal.id === selectedVal
              );
              
              if (exchangeEntry) {
                // Return the key (what the dropdown expects)
                return exchangeEntry[0];
              }
              
              // If not found or already a key, return as-is
              return selectedVal;
            });
          }

          ACTIVE_CRITERIA.push(criteriaItem);
        }
      });

      state.ACTIVE_CRITERIA = ACTIVE_CRITERIA;

      state.ACTIVE_CRITERIA.forEach(criteria => {
        if (criteria.id === 'sectors') {
          state.SECTOR_LIST_SELECTED = criteria.selected;
        }
      });
    },

    SET_ACTIVE_CRITERIA_FROM_SESSION(state, ACTIVE_CRITERIA) {
      state.ACTIVE_CRITERIA = ACTIVE_CRITERIA;
      
      state.ACTIVE_CRITERIA.forEach(criteria => {
        if (criteria.id === 'sectors') {
          state.SECTOR_LIST_SELECTED = criteria.selected;
        } else if (criteria.id === 'exchangeGroups' && (!criteria.list || criteria.list.length === 0)) {
          // Populate exchangeGroups list if it's empty
          criteria.list = [];
          Object.entries(state.AVAILABLE_EXCHANGES).forEach(([key, exchangeVal]) => {
            let dname;
            if (exchangeVal.id == 'TSV') {
              dname = 'TSXV';
            } else if (exchangeVal.id == 'CNQ') {
              dname = 'CSE';
            } else {
              dname = exchangeVal.id
            }
            criteria.list.push({
              label: dname,
              type: key,
              displayname: exchangeVal.id,
            });
          });
        } else if (criteria.id === 'exchangeGroups' && criteria.selected) {
          // Convert exchange IDs to keys if needed (ensure compatibility with saved data)
          criteria.selected = criteria.selected.map(selectedVal => {
            // Check if selectedVal is an exchange ID (like "AMX", "NSD", "NYE")
            // If so, find the corresponding key
            const exchangeEntry = Object.entries(state.AVAILABLE_EXCHANGES).find(([, exchangeVal]) => 
              exchangeVal.id === selectedVal
            );
            
            if (exchangeEntry) {
              // Return the key (what the dropdown expects)
              return exchangeEntry[0];
            }
            
            // If not found or already a key, return as-is
            return selectedVal;
          });
        }
      });
    },
    SET_EQUITY_CRITERIA(state, EQUITY_CRITERIA) {
      state.ACTIVE_CRITERIA.forEach(option => {
        let idToMatch = option.id;
        EQUITY_CRITERIA.every(filter => {
          let match = filter.fixedFilters.find(x => x.id == idToMatch);
          if (!match) {
            match = filter.rangedFilters.find(x => x.id == idToMatch);
          }
          if (match) {
            option.displayname = match.name;
            return false;
          }
          return true;
        })
      })
      state.EQUITY_CRITERIA = EQUITY_CRITERIA;
    },
    SET_FIXED_FILTERS(state, FIXED_FILTERS) {
      FIXED_FILTERS.forEach((element) => {
        element.dropdown = Object.assign({
          selected: 0,
          list: [],
          open: false,
        });
        Object.entries(element.value).forEach(([key, val]) => {
          element.dropdown.list.push({
            label: val,
            type: key,
          });
        });
      });

      state.FIXED_FILTERS = FIXED_FILTERS;
    },
    SET_COMPONENT_DATA(state, componentData) {
      state.componentData = componentData;
    },
    UPDATE_ACTIVE_CRITERIA_LIST_BY_ID(state, ACTIVE_CRITERIA_TO_UPDATE) {

      const item = state.ACTIVE_CRITERIA.find(
        (item) => item.id === ACTIVE_CRITERIA_TO_UPDATE.id
      );

      item.minRange = ACTIVE_CRITERIA_TO_UPDATE.selectedmin;
      item.maxRange = ACTIVE_CRITERIA_TO_UPDATE.selectedmax;
      item.rangeSize = ACTIVE_CRITERIA_TO_UPDATE.selectedtotal;
      item.selected = ACTIVE_CRITERIA_TO_UPDATE.selected;
    },
    INIT_VIEWS(state, VIEWS) {
      state.CUSTOM_TABS = VIEWS;

      // localStorage.setItem('QMOD_SCREENER_CUSTOM_TABS', JSON.stringify(CUSTOM_TABS_LS));
    },
  },
  actions: {
    async setView({
      state,
      commit,
      dispatch,
      getters,
      rootState
    }) {
      let URL = `//${rootState.ENV}.quotemedia.com/screener/views/datatool/type/equity?wmid=${rootState.WMID}&token=${state.componentToken
        }${rootState.SID ? '&sid=' + rootState.SID : ''
        }`;
      let jsonData = {
        view: JSON.stringify(state.CUSTOM_TABS['equity'][0])
      };
      try {
        const response = await axios.post(URL, jsonData);

      }
      catch (e) {

      }
    },
    async getViews({
      state,
      commit,
      dispatch,
      getters,
      rootState
    }) {
      let URL = `//${rootState.ENV}.quotemedia.com/screener/views/datatool/?wmid=${rootState.WMID}&token=${state.componentToken
        }${rootState.SID ? '&sid=' + rootState.SID : ''
        }`;
      try {
        const response = await axios.get(URL);
        let rViews = response.data;
        let cViews = {};

        if (rViews.views.length) {
          rViews.views.forEach(view => {
            let TYPE = view.type.toLocaleLowerCase();
            cViews[TYPE] = cViews[TYPE] ? cViews[TYPE] : []
            cViews[TYPE].push(JSON.parse(view.view))
          })
          commit('INIT_VIEWS', cViews)
        }

        // commit('INIT_VIEWS')
      }
      catch (e) {

      }
    },
    async changeScreener({
      state,
      commit,
      dispatch,
      getters
    }, screener) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ALL");
      commit("SET_CURRENT_SCREENER", screener);

      let country = getters.gCurrentCountry || 'CA';

      await dispatch("getEquityCriteria", country);
      commit("SET_IS_LOADING", false);
    },
    async getSectors({
      state,
      commit,
      dispatch,
      getters,
      rootState
    }, currentPage) {
      let URL = `//${rootState.ENV}.quotemedia.com/datatool/getGlobalIndustrySectorCodeList.json?token=${state.componentToken
        }${rootState.SID ? '&sid=' + rootState.SID : ''
        }`;

      try {
        const response = await axios.get(URL);
        let flatlist = [];
        response.data.results.sector.forEach((sector) => {
          flatlist.push({
            label: sector.name,
            type: sector.code,
            parent: null,
          });
          sector.group.forEach((group) => {
            flatlist.push({
              label: "-" + group.name,
              type: group.code,
              parent: sector.code,
            });
            group.group = group.industry;
            group.industry.map((industry) => {
              flatlist.push({
                label: "--" + industry.name,
                type: industry.code,
                parent: group.code,
              });
            });
          });
        });
        commit("SET_SECTOR_LIST_TREE", response.data.results.sector);
        commit("SET_SECTOR_LIST", flatlist);

        // commit("SET_FILTERED_RESULTS", response.data.results.quote);
        // commit("SET_IS_LOADING", false);
      } catch (e) {
        throw e;
      }
    },
    async getQuoteForExport({
      state,
      commit,
      dispatch,
      getters,
      rootState
    }, currentPage) {
      let cutLimit = state.SYMBOL_LIST.slice(0, 1000);
      let amountOfCalls = cutLimit.length;
      let sliceAmount = 0;
      let sliceLimit = 100;

      let mergeArray = [];


      let country = getters.gCurrentCountry || 'CA';
      let instrument_type = state.CURRENT_SCREENER == 'etf' ? 'etf' : 'mutualfund';
      let apiPath = state.CURRENT_SCREENER == 'equity' ? 'equities' : 'funds';

      let URL = `//${rootState.ENV}.quotemedia.com/v2/screener/${apiPath}`

      let URLParams = {
        country: country,
        module: 'datatool',
        webmaster_id: rootState.WMID,
        token: state.componentToken,
        ...(rootState.SID && {sid: rootState.SID}),
        ...(state.CURRENT_SCREENER != 'equity' && {instrument_type: instrument_type})
      }

      while (amountOfCalls > 0) {
        var currentSymbolList = cutLimit.slice(sliceAmount, (sliceAmount + sliceLimit));
        amountOfCalls -= sliceLimit;
        sliceAmount += 100;

        URLParams.symbols = currentSymbolList.toString();

        try {
          const response = await axios.get(URL, {
            params: URLParams
          });
          
          mergeArray = mergeArray.concat(response.data.results[apiPath]);

        } catch (e) {
          throw e;
        }
      }

      commit("SET_EXPORT", mergeArray);


    },
    async getQuoteByPage({
      state,
      commit,
      dispatch,
      getters,
      rootState
    }, currentPage) {
      commit("SET_IS_LOADING", true);
      
      let page = (currentPage * state.RESULTS_PER_PAGE) - state.RESULTS_PER_PAGE;
      let endPage = (currentPage * state.RESULTS_PER_PAGE);
      let currentSymbolList = state.SYMBOL_LIST.slice(page, endPage);

      let URLParams = {
        symbols: currentSymbolList,
        webmaster_id: rootState.WMID,
        module: 'datatool',
        token: state.componentToken,
        ...(rootState.SID && {sid: rootState.SID})
      }
      let URL = `//${rootState.ENV}.quotemedia.com/v2/screener/equities`

      try {
        const response = await axios.get(URL, {
            params: URLParams
          }
        );

        commit("SET_FILTERED_RESULTS", response.data.results.equities);
        commit("SET_IS_LOADING", false);
      } catch (e) {
        throw e;
      }
    },
    async getFundByPage({
      state,
      commit,
      dispatch,
      getters,
      rootState
    }, currentPage) {
      commit("SET_IS_LOADING", true);
      let page = (currentPage * state.RESULTS_PER_PAGE) - state.RESULTS_PER_PAGE;
      let endPage = (currentPage * state.RESULTS_PER_PAGE);
      let currentSymbolList = state.SYMBOL_LIST.slice(page, endPage);

      let country = getters.gCurrentCountry || 'CA';
      let instrument_type = state.CURRENT_SCREENER == 'etf' ? 'etf' : 'mutualfund';
      let apiPath = state.CURRENT_SCREENER == 'equity' ? 'equities' : 'funds';

      let URLParams = {
        symbols: currentSymbolList.toString(),
        country: country,
        module: 'datatool',
        webmaster_id: rootState.WMID,
        token: state.componentToken,
        ...(rootState.SID && {sid: rootState.SID}),
        ...(state.CURRENT_SCREENER != 'equity' && {instrument_type: instrument_type})
      }

      let URL = `//${rootState.ENV}.quotemedia.com/v2/screener/${apiPath}`

      try {
        const response = await axios.get(URL, {
            params: URLParams
          }
        );

        commit("SET_FILTERED_RESULTS", response.data.results[apiPath]);
        commit("SET_IS_LOADING", false);
      } catch (e) {
        throw e;
      }
    },
    async getFilteredResults({
      state,
      commit,
      dispatch,
      getters,
      rootState
    }) {
      commit("SET_IS_LOADING", true);
      this.criteriaResults = [];

      // var fixedCriteria = getters.gActiveCriteria.reduce(function (obj, itm) {
      //     if (!itm.selected) return obj;
      //     if (itm.id === "sectors") {
      //         if (!getters.gSectorSelected) return obj;
      //         let array2 = getters.gSectorSelected;
      //         // itm.selected.map((sector) => {
      //         //   array2.push(itm.list.find((sec) => sec.type == sector).type);
      //         // });
      //         obj[itm.id] = array2; //["AMX"]; //itm.selected;
      //     } else if (itm.id === "exchangeGroups") {
      //         let array2 = [];
      //         itm.selected.map((exch) => {

      //             array2.push(itm.list[exch].displayname);
      //         });
      //         obj[itm.id] = array2; //["AMX"]; //itm.selected;
      //     } else {

      //         let isTrueSet = (itm.selected == 'true');
      //         obj[itm.id] = isTrueSet;
      //     }
      //     // obj[itm.id] = [itm.list[itm.selected].label]; //["AMX"]; //itm.selected;

      //     return obj;
      // }, {});

      var rangeCriteria = getters.gActiveCriteria.reduce(function (obj, itm) {
        if (itm.selected) return obj;
        obj[itm.id] = itm.minRange + ":" + itm.maxRange;

        return obj;
      }, {});

      var fixedCriteria = getters.gActiveCriteria.reduce(function (obj, itm) {
        if (!itm.selected) return obj;
        if (itm.list) { // drop down list
          if (itm.id === "topHoldings") {
            if (itm.selected[0] !== '0') {
              obj[itm.id] = itm.selected;
            }

          }

          else if (itm.list[0].label == "true" || itm.list[0].label === "Yes") { // true false drop downs 
            obj[itm.id] = (itm.selected == 'true' || itm.selected == 0) ? true : false;
          }

          else if (itm.id === "sectors") {
            if (!getters.gSectorSelected) return obj;
            let array2 = getters.gSectorSelected;

            // itm.selected.map((sector) => {
            //   array2.push(itm.list.find((sec) => sec.type == sector).type);
            // });
            obj[itm.id] = array2; //["AMX"]; //itm.selected;
          }

          else {
            let array2 = [];
            if (Array.isArray(itm.selected)) {
              itm.selected.map((selectedItem) => {
                // Check if list exists and has the selectedItem as a key (old format)
                if (itm.list && itm.list[selectedItem]) {
                  array2.push(itm.list[selectedItem].label);
                } else {
                  // New format - the selected values are already the labels/values
                  array2.push(selectedItem);
                }
              });
            }

            obj[itm.id] = array2;
          }
        }
        return obj;
      }, {});

      if (!rangeCriteria) return;

      let country = getters.gCurrentCountry || 'CA';

      fixedCriteria =
        Object.keys(fixedCriteria).length === 0 ? null : fixedCriteria;
      try {
        let jsonData = {};
        if (rangeCriteria) {
          jsonData['rangeCriteria'] = rangeCriteria
        }
        if (fixedCriteria) {
          jsonData['fixedCriteria'] = fixedCriteria
        }

        let filterURL = `//${rootState.ENV}.quotemedia.com/screener/${state.CURRENT_SCREENER}/datatool/filter/${country}?webmaster_id=${rootState.WMID}&token=${state.componentToken
          }${rootState.SID ? '&sid=' + rootState.SID : ''
          }`;

        // if (state.SORT_TABLE.by!='') {
        //     filterURL += `&sort_by=${state.SORT_TABLE.sortKey}&sort_order=${state.SORT_TABLE.direction}`
        // }

        const criteriaResults = await axios.post(
          filterURL, jsonData
        );

        state.CURRENT_PAGE = 1;

        let symbolList = criteriaResults.data.symbols.map((item) => {
          return item;
        });

        commit("SET_SYMBOL_LIST", symbolList);
        let currentSymbolList = symbolList.slice(0, state.RESULTS_PER_PAGE);

        let instrument_type = state.CURRENT_SCREENER == 'etf' ? 'etf' : 'mutualfund';
        let apiPath = state.CURRENT_SCREENER == 'equity' ? 'equities' : 'funds';


        let URL = `//${rootState.ENV}.quotemedia.com/v2/screener/${apiPath}?token=${state.componentToken
          }&instrument_type=${instrument_type}&module=datatool&webmaster_id=${rootState.WMID}&country=${country}&symbols=${currentSymbolList}${rootState.SID ? '&sid=' + rootState.SID : ''}`;



        commit("SET_TOTAL_RESULTS", criteriaResults.data.totalCount);

        try {
          if (currentSymbolList.length) {
            const response = await axios.get(URL);
            commit(
              "SET_FILTERED_RESULTS",
              response.data.results[apiPath] ? response.data.results[apiPath] : []
            );
          }
          else {
            commit(
              "SET_FILTERED_RESULTS",
              []
            );
          }

        } catch (e) {
          throw e;
        }
        commit("SET_IS_LOADING", false);
      } catch (e) {
        return "INVALID";
      }
    },
    async setEquityFromScreens({
      state,
      commit,
      dispatch,
      getters
    },
      newCriteria
    ) {

      commit("CLEAR_ALL_PESETS");
      let filters = getters.gEquityCriteria;
      let filterstofind = [];

      filters.forEach(function (v, idx) {
        v.rangedFilters.forEach(function (v1, idx1) {
          filterstofind.push(v1);
        });
        v.fixedFilters.forEach(function (v1, idx1) {
          filterstofind.push(v1);
        });
      });

      let ranges;
      let fixeds;

      if (newCriteria.rangedFilters && newCriteria.rangedFilters.length > 0) {
        ranges = newCriteria.rangedFilters.map(async function (filters, idx4) {
          let item = filterstofind.find((x) => x.id === filters.alias);
          if (!item) {
            console.warn(`Could not find criteria item with id: ${filters.alias}`);
            return;
          }
          
          if (item && item.list) {
            filters.list = item.list;
            // Don't overwrite saved selected values - only set default if no saved values exist
            if (!filters.selected) {
              filters.selected = item.selected;
            } else if (filters.alias === 'exchangeGroups') {
              // Convert exchange IDs to keys for exchangeGroups
              filters.selected = filters.selected.map(selectedVal => {
                // Check if selectedVal is an exchange ID (like "AMX", "NSD", "NYE")
                const exchangeEntry = Object.entries(state.AVAILABLE_EXCHANGES).find(([key, exchangeVal]) => 
                  exchangeVal.id === selectedVal
                );
                
                if (exchangeEntry) {
                  // Return the key (what the dropdown expects)
                  return exchangeEntry[0];
                }
                
                // If not found or already a key, return as-is
                return selectedVal;
              });
            }
            
            // Update item.selected with the converted values before committing
            item.selected = filters.selected;
          } else if (item) {
            // Handle new format filters that don't have .list but may have selected values
            // For ranged filters or other criteria that were saved with specific values
            if (filters.selected !== undefined) {
              item.selected = filters.selected;
            }
            
            // Handle min/max values for ranged filters
            if (filters.min !== undefined) {
              item.minRange = filters.min;
            }
            if (filters.max !== undefined) {
              item.maxRange = filters.max;
            }
          }

          commit('SET_SELECTED_CRITERA', item);

          if (state.CURRENT_SCREENER == 'equity') {
            await dispatch("getequityPreviewRange", item);
          }
          else {
            await dispatch("getFundPreviewRange", item);
          }

          // item.selectedmin = 127
          // item.selectedmax = 202
          let aFilters = getters.gActiveCriteria;
          filters.id = filters.alias;

          if (filters.min === "min") {
            let item2 = aFilters.find((x) => x.id === filters.alias);
            filters.selectedmin = item2.histogram.steps[0];
          } else {
            filters.selectedmin = filters.min;
          }
          if (filters.max === "max") {
            let item2 = aFilters.find((x) => x.id === filters.alias);
            filters.selectedmax =
              item2.histogram.steps[item2.histogram.steps.length - 1];
          } else {
            filters.selectedmax = filters.max;
          }

          await dispatch("getEquityPreviewCount", filters);
        });

      if (newCriteria.fixedFilters && newCriteria.fixedFilters.length > 0) {
        fixeds = newCriteria.fixedFilters.map(async function (filters, idx4) {
          let item = filterstofind.find((x) => x.id === filters.alias);
          if (!item) {
            console.warn(`Could not find criteria item with id: ${filters.alias}`);
            return;
          }
          
          if (item && item.list) {
            filters.list = item.list;
            // Don't overwrite saved selected values - only set default if no saved values exist
            if (!filters.selected) {
              filters.selected = item.selected;
            } else if (filters.alias === 'exchangeGroups') {
              // Convert exchange IDs to keys for exchangeGroups
              filters.selected = filters.selected.map(selectedVal => {
                // Check if selectedVal is an exchange ID (like "AMX", "NSD", "NYE")
                const exchangeEntry = Object.entries(state.AVAILABLE_EXCHANGES).find(([, exchangeVal]) => 
                  exchangeVal.id === selectedVal
                );

                if (exchangeEntry) {
                  // Return the key (what the dropdown expects)
                  return exchangeEntry[0];
                }
                
                // If not found or already a key, return as-is
                return selectedVal;
              });
            }
            
            // Update item.selected with the converted values before committing
            item.selected = filters.selected;
          } else if (item) {
            // Handle new format filters that don't have .list but may have selected values
            // For ranged filters or other criteria that were saved with specific values
            if (filters.selected !== undefined) {
              item.selected = filters.selected;
            }
            
            // Handle min/max values for ranged filters
            if (filters.min !== undefined) {
              item.minRange = filters.min;
            }
            if (filters.max !== undefined) {
              item.maxRange = filters.max;
            }
          }

          commit('SET_SELECTED_CRITERA', item);

          if (state.CURRENT_SCREENER == 'equity') {
            await dispatch("getequityPreviewRange", item);
          }
          else {
            await dispatch("getFundPreviewRange", item);
          }
          // item.selectedmin = 127
          // item.selectedmax = 202 
          let aFilters = getters.gActiveCriteria;
          filters.id = filters.alias;
          if (filters.min === "min") {
            let item2 = aFilters.find((x) => x.id === filters.alias);
            filters.selectedmin = item2.histogram.steps[0];
          } else {
            filters.selectedmin = filters.min;
          }
          if (filters.max === "max") {
            let item2 = aFilters.find((x) => x.id === filters.alias);
            filters.selectedmax =
              item2.histogram.steps[item2.histogram.steps.length - 1];
          } else {
            filters.selectedmax = filters.max;
          }

          if (state.CURRENT_SCREENER == 'equity') {
            await dispatch("getEquityPreviewCount", filters);
          }
          else {
            await dispatch("getFundPreviewCount", filters);
          }
        });
      }


      // Wait for all filters to complete processing
      const promises = [];
      if (ranges) promises.push(Promise.all(ranges));
      if (fixeds) promises.push(Promise.all(fixeds));
      
      if (promises.length > 0) {
        await Promise.all(promises);
      }
      
      await dispatch("getFilteredResults");
    }
    },
    async getEquityPreviewCount({
      state,
      commit,
      getters,
      rootState
    }, newCriteria) {
      let requestProps = {};

      if (newCriteria.data) {
        newCriteria = newCriteria.data.preview[0];

        if (newCriteria.id == 'exchangeGroups') {
          let combined = []
          newCriteria.selected.forEach(enabledEX => {
            // Check if list exists and has the enabledEX as a key (old format)
            if (newCriteria.list && newCriteria.list[enabledEX]) {
              combined.push(newCriteria.list[enabledEX].label)
            } else {
              // New format - the selected values are already the exchange names
              combined.push(enabledEX)
            }
          })

          requestProps[`fixedCriteria.${newCriteria.id}`] = combined.join(',')
        } else if (newCriteria.id == 'sectors') {
          requestProps[`fixedCriteria.${newCriteria.id}`] = newCriteria.selected.join(',')
        } else if (newCriteria.selected) {
          //Problem with changing true/false to yes no
          if (newCriteria.list[newCriteria.selected]) {
            requestProps[`fixedCriteria.${newCriteria.id}`] = newCriteria.list[newCriteria.selected].label
          }
          else {
            requestProps[`fixedCriteria.${newCriteria.id}`] = newCriteria.selected
          }

        }

        else
          return
      } else {
        if (newCriteria.id == 'exchangeGroups') {
          let combined = []
          newCriteria.selected.forEach(enabledEX => {
            // Check if list exists and has the enabledEX as a key (old format)
            if (newCriteria.list && newCriteria.list[enabledEX]) {
              combined.push(newCriteria.list[enabledEX].label)
            } else {
              // New format - the selected values are already the exchange names
              combined.push(enabledEX)
            }
          })

          requestProps[`fixedCriteria.${newCriteria.id}`] = combined.join(',')
        } else if (newCriteria.id == 'sectors') {
          requestProps[`fixedCriteria.${newCriteria.id}`] = newCriteria.selected.join(',')
        } else if (newCriteria.selected) {
          if (newCriteria.selected instanceof Array) {
            let array2 = []
            newCriteria.selected.map((selectedItem) => {
              // Check if list exists and has the selectedItem as a key (old format)
              if (newCriteria.list && newCriteria.list[selectedItem]) {
                array2.push(newCriteria.list[selectedItem].label);
              } else {
                // New format - the selected values are already the labels/values
                array2.push(selectedItem);
              }
            });
            requestProps[`fixedCriteria.${newCriteria.id}`] = array2.join(',')
          }
        } else {
          requestProps[`rangeCriteria.${newCriteria.id}`] = `${newCriteria.selectedmin
            }:${newCriteria.selectedmax}`;
        }

      }

      let country = getters.gCurrentCountry || 'CA';

      try {
        // debounce(async () => {
        const rangeResults = await axios.get(
          `//${rootState.ENV}.quotemedia.com/screener/${state.CURRENT_SCREENER}/datatool/preview/${country}/count/selected?webmaster_id=${rootState.WMID}&token=${state.componentToken
          }${rootState.SID ? '&sid=' + rootState.SID : ''
          }`, {
          //webmaster_id=501&userName=neiltest`, {
          params: requestProps,
        }
        );
        newCriteria.selectedtotal = rangeResults.data;
        commit("UPDATE_ACTIVE_CRITERIA_LIST_BY_ID", newCriteria);
        // commit("UPDATE_ACTIVE_CRITERIA_LIST", rangeResults.data.preview)
        // }, 2000)
      } catch (e) {
        // alert("JSON ERROR: 123 ", JSON.stringify(e));
        return "INVALID";
      }
    },
    async getFundFilteredResults({
      state,
      commit,
      dispatch,
      getters,
      rootState
    }) {
      commit("SET_IS_LOADING", true);
      this.criteriaResults = [];

      var fixedCriteria = getters.gActiveCriteria.reduce(function (obj, itm) {
        if (!itm.selected) return obj;
        if (itm.list) { // drop down list
          if (itm.id === "topHoldings") {
            if (itm.selected[0] !== '0') {
              obj[itm.id] = itm.selected;
            }

          }
          else if (itm.list[0].label === 'true') { // true false drop downs 
            // Use the same logic as the first function for consistency
            obj[itm.id] = (itm.selected == 'true' || itm.selected == 0) ? true : false;
          }
          else if (itm.id === "sectors") {
            if (!getters.gSectorSelected) return obj;
            let array2 = getters.gSectorSelected;
            // itm.selected.map((sector) => {
            //   array2.push(itm.list.find((sec) => sec.type == sector).type);
            // });
            obj[itm.id] = array2; //["AMX"]; //itm.selected;
          }
          else {
            let array2 = [];
            itm.selected.map((selectedItem) => {
              // Check if list exists and has the selectedItem as a key (old format)
              if (itm.list && itm.list[selectedItem]) {
                array2.push(itm.list[selectedItem].label);
              } else {
                // New format - the selected values are already the labels/values
                array2.push(selectedItem);
              }
            });

            obj[itm.id] = array2;
          }
        }
        return obj;
      }, {});

      var rangeCriteria = getters.gActiveCriteria.reduce(function (obj, itm) {
        if (itm.selected) return obj;
        obj[itm.id] = itm.minRange + ":" + itm.maxRange;

        return obj;
      }, {});

      if (!rangeCriteria) return;

      let country = getters.gCurrentCountry || 'CA';

      fixedCriteria =
        Object.keys(fixedCriteria).length === 0 ? null : fixedCriteria;
      try {
        let jsonData = {};
        if (rangeCriteria) {
          jsonData['rangeCriteria'] = rangeCriteria
        }
        if (fixedCriteria) {
          jsonData['fixedCriteria'] = fixedCriteria
        }


        const criteriaResults = await axios.post(
          `//${rootState.ENV}.quotemedia.com/screener/${state.CURRENT_SCREENER}/datatool/filter/${country}?webmaster_id=${rootState.WMID}&token=${state.componentToken
          }${rootState.SID ? '&sid=' + rootState.SID : ''
          }`, jsonData
        );

        state.CURRENT_PAGE = 1;

        let symbolList = criteriaResults.data.symbols.map((item) => {
          return item;
        });

        commit("SET_SYMBOL_LIST", symbolList);
        commit("SET_TOTAL_RESULTS", criteriaResults.data.totalCount);
        commit("SET_IS_LOADING", false);
        if (criteriaResults.data.totalCount > 0) {
          await dispatch("getFundByPage", 1);
        }
        else {
          commit("SET_FILTERED_RESULTS", []);

        }

      } catch (e) {
        return "INVALID";
      }
    },
    async getFundPreviewCount({
      state,
      commit,
      getters,
      rootState
    }, newCriteria) {
      let requestProps = {};


      if (newCriteria) {
        // newCriteria = newCriteria.data.preview[0];

        if (newCriteria.list) {
          if (newCriteria.id == 'topHoldings') {
            return;
          }
          else {
            requestProps[`fixedCriteria.${newCriteria.id}`] = newCriteria.selected.map(v => {
              // Check if list exists and has the v as a key (old format)
              if (newCriteria.list && newCriteria.list[v]) {
                return newCriteria.list[v].label;
              } else {
                // New format - the selected values are already the labels/values
                return v;
              }
            }).join(',');
          }

        }

        //newCriteria.selected; //newCriteria.list[newCriteria.selected].label
      }

      let country = getters.gCurrentCountry || 'CA';

      try {
        // debounce(async () => {
        const rangeResults = await axios.get(
          `//${rootState.ENV}.quotemedia.com/screener/${state.CURRENT_SCREENER}/datatool/preview/${country}/count/selected?webmaster_id=${rootState.WMID}&token=${state.componentToken
          }${rootState.SID ? '&sid=' + rootState.SID : ''
          }`, {
          params: requestProps,
        }
        );
        newCriteria.selectedtotal = rangeResults.data;
        commit("UPDATE_ACTIVE_CRITERIA_LIST_BY_ID", newCriteria);

      } catch (e) {
        // alert("JSON ERROR: 123 ", JSON.stringify(e));
        return "INVALID";
      }
    },
    async getFundPreviewRange({
      state,
      commit,
      getters,
      rootState,
      dispatch
    }, activeCriteria) {
      let rangeResults = {};

      if (activeCriteria.values) { // fixed filter with drop down options.

        rangeResults.list = [];
        Object.entries(activeCriteria.values).forEach(([key, val]) => {
          rangeResults.list.push({
            label: val,
            type: key,
          });
        });

        if (activeCriteria.id == 'topHoldings') {
          rangeResults.selected = [];
        }
        else {
          rangeResults.selected = ["0"];
        }

        rangeResults.id = activeCriteria.id;

        rangeResults.percent = activeCriteria.percent;
        rangeResults.date = activeCriteria.date;
        rangeResults.displayname = activeCriteria.name || activeCriteria.displayname;
        rangeResults.isFund = true;
        rangeResults.selectedtotal = 0;
        rangeResults.rangeSize = 0;
        commit("UPDATE_ACTIVE_CRITERIA_LIST", [rangeResults]);
        await dispatch("getFundPreviewCount", rangeResults);
      }
      else { // range criteria / historgram

        let country = getters.gCurrentCountry || 'CA';

        try {

          // debounce(async () => {
          let rangeCriteria = {
            rangeFilterNames: `${activeCriteria.id}`,
          };
          const rangeResults = await axios.get(
            `//${rootState.ENV}.quotemedia.com/screener/${state.CURRENT_SCREENER}/datatool/preview/${country}?webmaster_id=${rootState.WMID}&token=${state.componentToken
            }${rootState.SID ? '&sid=' + rootState.SID : ''
            }`, {
            //webmaster_id=501&userName=neiltest`, {
            params: rangeCriteria,
          }
          );

          rangeResults.data.preview[0].percent = activeCriteria.percent;
          rangeResults.data.preview[0].date = activeCriteria.date;
          rangeResults.data.preview[0].displayname = activeCriteria.name || activeCriteria.displayname;
          commit("UPDATE_ACTIVE_CRITERIA_LIST", rangeResults.data.preview);
          await dispatch("getEquityPreviewCount", rangeResults);
        } catch (e) {
          alert("JSON ERROR: ", JSON.stringify(e));
          return "INVALID";
        }
      }
      await dispatch("getFundFilteredResults");

    },
    async getequityPreviewRange({
      state,
      commit,
      getters,
      rootState,
      dispatch
    }, newCriteria) {
      let combinedRequest = state.ACTIVE_CRITERIA;
      let rangeCriteria;
      let isFixed;

      let rangeResults;

      let alreadyExists = combinedRequest.find(critera => critera.id == newCriteria.id);

      if (alreadyExists && alreadyExists.length > 0) {
        return;
      }

      if (newCriteria.value) {
        return;
      } else {
        if (newCriteria.values || newCriteria.id == 'low52week' || newCriteria.id == 'high52week' || newCriteria.id == 'optionable' || newCriteria.id == 'sectors' || newCriteria.id == 'exchangeGroups' || newCriteria.id == 'primarysymbol' || newCriteria.id == 'filingcurrent') {
          isFixed = true;
          rangeCriteria = {
            rangeFilterNames: newCriteria.id
          }
        } else {
          rangeCriteria = {
            rangeFilterNames: `${newCriteria.id}`,
          };
        }
      }
      let country = getters.gCurrentCountry || 'CA';

      try {
        // debounce(async () => {
        if (!isFixed) {
          rangeResults = await axios.get(
            `//${rootState.ENV}.quotemedia.com/screener/${state.CURRENT_SCREENER}/datatool/preview/${country}?webmaster_id=${rootState.WMID}&token=${state.componentToken
            }${rootState.SID ? '&sid=' + rootState.SID : ''
            }`, {
            //webmaster_id=501&userName=neiltest`, {
            params: rangeCriteria,
          }
          );
        }
        else {
          rangeResults = {
            data: {
              preview: [
                {

                }
              ]
            }
          }
        }

        if (newCriteria.id == "sectors") {
          rangeResults.data.preview[0].list = state.SECTOR_LIST;
          rangeResults.data.preview[0].selected = [101];
          rangeResults.data.preview[0].id = newCriteria.id;
        } else if (newCriteria.id == 'exchangeGroups') {
          rangeResults.data.preview[0].list = []

          Object.entries(state.AVAILABLE_EXCHANGES).forEach(([key, val]) => {
            let dname;
            if (val.id == 'TSV') {
              dname = 'TSXV';
            } else if (val.id == 'CNQ') {
              dname = 'CSE';
            } else {
              dname = val.id
            }
            rangeResults.data.preview[0].list.push({
              label: dname,
              type: key,
              displayname: val.id,
            });
          });
          // Preserve existing selected values if they exist, otherwise use default
          rangeResults.data.preview[0].selected = newCriteria.selected || ['0'];
          rangeResults.data.preview[0].id = newCriteria.id;
        } else if ((
          newCriteria.id == 'low52week' ||
          newCriteria.id == 'high52week' ||
          newCriteria.id == 'optionable' ||
          newCriteria.id == 'primarysymbol' ||
          newCriteria.id == 'filingcurrent'
        )) {
          rangeResults.data.preview[0].list = [];
          rangeResults.data.preview[0].list.push({
            label: 'Yes',
            type: 'true',
          });
          rangeResults.data.preview[0].list.push({
            label: 'No',
            type: 'false',
          });
          rangeResults.data.preview[0].selected = 'true';
          rangeResults.data.preview[0].id = newCriteria.id;

        } else if (newCriteria.values) {
          rangeResults.data.preview[0].list = [];
          Object.entries(newCriteria.values).forEach(([key, val]) => {
            rangeResults.data.preview[0].list.push({
              label: val,
              type: key,
            });
          });
          rangeResults.data.preview[0].selected = ["0"];
          rangeResults.data.preview[0].id = newCriteria.id;
        }

        rangeResults.data.preview[0].date = newCriteria.date;
        rangeResults.data.preview[0].percent = newCriteria.percent;
        rangeResults.data.preview[0].displayname = newCriteria.displayname || newCriteria.name;
        
        if (newCriteria.minRange) {
          rangeResults.data.preview[0].minRange = newCriteria.minRange;
          rangeResults.data.preview[0].maxRange = newCriteria.maxRange;          
        }

        commit("UPDATE_ACTIVE_CRITERIA_LIST", rangeResults.data.preview);
        await dispatch("getEquityPreviewCount", rangeResults);
        // }, 2000)
      } catch (e) {
        alert("JSON ERROR: ", JSON.stringify(e));
        return "INVALID";
      }
    },
    async getExchanges({
      state,
      commit,
      getters,
      dispatch,
      rootState
    }) {
      let country = getters.gCurrentCountry || 'CA';


      try {
        const getExchanges = await axios.get(
          `//${rootState.ENV}.quotemedia.com/screener/${state.CURRENT_SCREENER}/datatool/preview/${country}/count/?webmaster_id=${rootState.WMID}&token=${state.componentToken
          }${rootState.SID ? '&sid=' + rootState.SID : ''
          }`
        );
        getExchanges.data.countPreviewList.pop()
        commit("SET_EXCHANGES", getExchanges.data.countPreviewList);
      } catch (e) {
        alert("JSON ERROR: ", JSON.stringify(e));

        return "INVALID";
      }
    },
    async getEquityCriteria({
      state,
      commit,
      getters,
      dispatch,
      rootState
    }, countryInput) {
      try {
        let country = getters.gCurrentCountry || 'CA';
        let screenerType = '';

        const getJSON = await axios.get(
          `//${rootState.ENV}.quotemedia.com/screener/${state.CURRENT_SCREENER}/datatool/criteria/${country}/?webmaster_id=${rootState.WMID}&token=${state.componentToken
          }&language=${state.LANG}${rootState.SID ? '&sid=' + rootState.SID : ''
          }` //webmaster_id=501&username=neiltest` //&token=${state.componentToken}
        );
        //fundCriteriaList
        let countryjson;
        if (getJSON.data.EquityCriteriaList) {
          screenerType = getJSON.data.EquityCriteriaList;

          countryjson = screenerType[2].fixedFilters.shift();
          screenerType[1].fixedFilters.splice(3, 1);
        } else if (getJSON.data.fundCriteriaList) {
          screenerType = getJSON.data.fundCriteriaList;
          countryjson = screenerType[0].fixedFilters.splice(1, 1)[0];
        }
        
        countryjson = {
          name: state.LANG === 'en' ? 'Country' : 'Pays',
          values: ['US', 'CA']
        };

        if (this.loadedFromParam) {
            const criteriaList = state.CURRENT_SCREENER === 'equity' ? getJSON.data.EquityCriteriaList : getJSON.data.fundCriteriaList;

            const flatCriteria = criteriaList.reduce((agg, item) => {
              return [...agg, ...item.fixedFilters];
            }, []); 

            state.ACTIVE_CRITERIA.forEach(async item => {
              if (item.id !== 'sectors') {
                if (item.list) {
                  const crit = flatCriteria.find( i => i.id === item.id );

                  if (!crit) {
                    throw Error(`Criteria "${item.id}" not found. Is "${item.id}" compatible with the screener type "${state.CURRENT_SCREENER}"?`)
                  }
    
                  crit.values = crit.values.map((label, type) => {
                    return {
                      label,
                      type: type.toString()
                    }
                  });
                  item.isFund = true;
                  item.list = crit.values;
                  if (state.CURRENT_SCREENER === 'equity') {
                    await dispatch("getEquityPreviewCount", item);  
                  } else {
                    await dispatch("getFundPreviewCount", item);
                  }

                } else {
                  
                  if (state.CURRENT_SCREENER === 'equity') {
                    await dispatch("getequityPreviewRange", item);  
                  } else {
                    await dispatch("getFundPreviewRange", item);
                  }
                }

              }
            });
        }


        // screenerType[1].fixedFilters.splice(1, 1);

        if (getters.gAvailableCountrys.length == 0) {
          commit("SET_COUNTRYS", countryjson);
        }
        commit("SET_EQUITY_CRITERIA", screenerType);

        if (state.CURRENT_SCREENER == 'equity') {
          const sectors = screenerType[0].fixedFilters[1].values

          let flatlist = [];
          sectors.forEach((sector) => {
            flatlist.push({
              label: sector.name,
              type: sector.code,
              parent: null,
            });
            sector.group.forEach((group) => {
              flatlist.push({
                label: "-" + group.name,
                type: group.code,
                parent: sector.code,
              });
              group.group = group.industry;
              group.industry.map((industry) => {
                flatlist.push({
                  label: "--" + industry.name,
                  type: industry.code,
                  parent: group.code,
                });
              });
            });
          });
          commit("SET_SECTOR_LIST_TREE", sectors);
          commit("SET_SECTOR_LIST", flatlist);

          const activeSectors = state.ACTIVE_CRITERIA.find((criteria) => criteria.id === 'sectors' );

          if (activeSectors) {
            activeSectors.list = flatlist;
          }
        }
        
        if (this.loadedFromParam) {
          await dispatch("getFilteredResults");
          this.loadedFromParam = false;
        }

        let searchCriteria = [];

        for (let i = 0; i < screenerType.length; i++) {
          const stateElement = screenerType[i];
          stateElement.fixedFilters.forEach(value => {
            value.parentID = stateElement.id;
          })
          stateElement.rangedFilters.forEach(value => {
            value.parentID = stateElement.id;
          })
          searchCriteria = searchCriteria.concat(stateElement.fixedFilters, stateElement.rangedFilters);
        }

        commit("SET_SEARCH_CRITERA", searchCriteria);

        await dispatch("getExchanges");
        // commit("SET_FIXED_FILTERS", getJSON.data.fixedFilter)
      } catch (e) {

        return "INVALID";
      }
    },
  },
};
